import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { PedidoService } from "src/app/core/services/pedido-service";
import { ProductService } from "src/app/core/services/product-service";
import { InitProvider } from "src/app/core/services/init-provider";
import { CorteService } from "src/app/modules/product/services/corte.service";

@Component({
  selector: "app-product-quantity-input",
  templateUrl: "./product-quantity-input.component.html",
  styleUrls: ["./product-quantity-input.component.css"],
})
export class ProductQuantityInputComponent implements OnInit {
  @Output()
  public onAdd = new EventEmitter<number>();
  @Input() product!: any;
  @Input()
  public produtoDescrHeight;
  public pedido: any;
  public quantity: number = 1;
  public inputClass: string = "";
  public SITE: any;
  public theme: any;
  public hovered: boolean = false;
  public error: boolean = false;
  public validaEstoque: boolean = true;
  public minQuantidade = 1
  public init = true
  private readonly casasDecimaisConversao = 3;

  constructor(
    public pedidoService: PedidoService,
    public initProvider: InitProvider,
    public toastService: ToastrService,
    private router: Router,
    private productService: ProductService,
    private corteService: CorteService
  ) {
    this.pedido = this.pedidoService.pedido;
    if (this.product && this.product.quantidade_minima) {
      // this.quantity = this.product.quantidade_minima;
      this.minQuantidade = this.product.quantidade_minima;
    }
    this.SITE = Configuracoes.SITE;
    this.theme = Configuracoes.themes.filter(
      (i) => i.id == Configuracoes.SITE.theme
    )[0];
  }

  /** Quando o backend marca permite_corte, o input vira somente leitura e o carrinho abre o formulário de corte. */
  public get somenteLeituraCorte(): boolean {
    if (!this.product) {
      return false;
    }
    return this.corteService.deveUsarPaginaCorte(this.product, false);
  }

  public redirecionarParaCorte(): void {
    if (!this.product || !this.product.id) {
      return;
    }
    this.productService.stashCurrentCatalogUiForReturn();
    this.router.navigate(["/produto-corte", this.product.id], {
      queryParams: { corte: "1" },
    });
  }

  ngOnInit(): void {
    if (this.pedidoService.pedido) {
      this.pedido = this.pedidoService.pedido;
      this.validaEstoque = this.pedidoService.pedido.tipo.validaEstoque;
    }
    if (this.product.quantidade_minima) {
      this.minQuantidade = this.product.quantidade_minima;
    }
    if (this.product.multiplo) {
      this.quantity = this.product.multiplo !== null ? this.product.multiplo : 1;
      this.inputClass = "disabled";
    } else if (this.product.quantidade_minima) {
      this.quantity = this.product.quantidade_minima;
    } else {
      this.quantity = 1
    }

    this.quantity = this.getQuantidadeDigitadaOrQuantidade();
  }
  ngDoCheck() {
    if (this.init) {
      this.quantity = this.getQuantidadeDigitadaOrQuantidade();
    } else {
      const v = this.getQuantidadeDigitadaOrQuantidade();
      this.quantity = v == null ? 1 : v;
    }
  }

  private getFatorConversao(): number | null {
    const fc = Number(this.product?.fator_conversao ?? this.product?.fatorConversao ?? null);
    if (!Number.isFinite(fc) || fc <= 0) {
      return null;
    }
    return fc;
  }

  private usaConversao(): boolean {
    return this.getFatorConversao() != null;
  }

  /** Quantidade exibida no input (digitada quando existir conversão). */
 private getQuantidadeDigitadaOrQuantidade(): number {
  if (!this.product) {
    return 1;
  }

  // 🔎 procura o item no pedido
  const itemPedido = this.pedido?.itens?.find(
    (item: any) => item.produto === this.product.id
  );

  // ✅ se encontrou no pedido
  if (itemPedido) {
    const candidato =
      itemPedido.quantidade_digitada ?? itemPedido.quantidade;

    const n = Number(candidato);
    if (Number.isFinite(n) && n > 0) {
      return n;
    }
  }

  // 🔁 fallback (sua lógica atual)
  const candidato =
    (this.usaConversao()
      ? this.product?.quantidade_digitada ?? this.product?.quantidadeDigitada
      : null) ??
    this.product?.quantidade;

  const n = Number(candidato);
  if (Number.isFinite(n) && n > 0) {
    return n;
  }

  const multiplo = this.product?.multiplo;
  if (multiplo != null) {
    const m = Number(multiplo);
    if (Number.isFinite(m) && m > 0) {
      return m;
    }
  }

  return 1;
}

  /** Quantidade em unidade de estoque, usada em validações/payload. */
  private getQuantidadeParaPedido(): number {
    if (!this.usaConversao()) {
      return Number(this.quantity) || 0;
    }
    const fc = this.getFatorConversao();
    if (!fc) {
      return Number(this.quantity) || 0;
    }
    const convertido = Number(this.quantity) * fc;
    if (!Number.isFinite(convertido)) {
      return 0;
    }
    return Number(convertido.toFixed(this.casasDecimaisConversao));
  }

  private persistirQuantidadeDigitadaEConvertida(): void {
    if (!this.product) {
      return;
    }
    if (!this.usaConversao()) {
      this.product.quantidade = Number(this.quantity);
      return;
    }
    const fc = this.getFatorConversao();
    if (!fc) {
      this.product.quantidade = Number(this.quantity);
      return;
    }
    this.product.quantidade_digitada = Number(this.quantity);
    this.product.unidade_digitada =
      this.product.unidade_digitada ?? this.product.unidadeDigitada ?? this.product.unidade_digitada;
    const convertido = this.getQuantidadeParaPedido();
    this.product.quantidade = convertido;
    this.product.quantidade_convertida = convertido;
    this.product.fator_conversao = fc;
  }

  public addCart() {
    const quantidadeParaPedido = this.getQuantidadeParaPedido();
    if (this.product.multiplo && this.quantity % this.product.multiplo > 0) {
      this.error = true;
      this.toastService.warning(
        $localize`Quantidade múltipla de (` + this.product.multiplo + $localize`) incorreta!`,
        $localize`Produto`,
        {
          positionClass: "toast-bottom-left",
        }
      );
      return;
    }
    // if(this.product.quantidade_minima){
    if (0 < this.quantity && this.quantity < this.product.quantidade_minima) {
      this.error = true;
      this.toastService.warning(
        $localize`Quantidade inferior ao mínimo de ${this.product.quantidade_minima}`,
        $localize`Produto`,
        {
          positionClass: "toast-bottom-left",
        }
      );
      return;
    }
    // }

    if (
      this.product.estoque < quantidadeParaPedido &&
      this.pedido.tipo.validaEstoque
    ) {
      this.error = true;
      this.toastService.warning($localize`Quantidade inválida. Verifique a quantidade minima e o estoque!`, $localize`Produto`, {
        positionClass: "toast-bottom-left",
      });
      return;
    }

    this.error = false;
    this.persistirQuantidadeDigitadaEConvertida();
    this.onAdd.emit(quantidadeParaPedido);
    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  public setQuantity(event) {
    this.init = false
    this.quantity = Number(event.target.value);
    this.persistirQuantidadeDigitadaEConvertida();
    this.inputClass = "";
  }

  public plus(multiplo: number) {
    this.init = false
    if (multiplo === null || multiplo === undefined) {
      multiplo = 1;
    }
    if (this.quantity === 0) {
      this.quantity = multiplo;
    } else if (this.quantity % multiplo === 0) {
      this.quantity = this.quantity + multiplo;
    } else {
      this.quantity = Math.ceil(this.quantity / multiplo) * multiplo;
    }
    this.persistirQuantidadeDigitadaEConvertida();
    this.inputClass = "";
    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  public less(multiplo: number) {
    this.init = false
    if (multiplo === null || multiplo === undefined) {
      multiplo = 1;
    }
    if (this.quantity === 0) {
      return;
    } else if (this.quantity === 1 || this.quantity < multiplo) {
      this.quantity = 0;
    }
    else if ((this.quantity - multiplo) < this.minQuantidade) {
      this.quantity = 0
    }
    else if (this.quantity % multiplo === 0) {
      this.quantity = this.quantity - multiplo;
    }
    else {
      this.quantity = Math.floor(this.quantity / multiplo) * multiplo;
    }
    this.persistirQuantidadeDigitadaEConvertida();
    this.inputClass = "";
    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  public updateQuantity(quantity) {
    this.quantity = Number(quantity) || 0;
    this.persistirQuantidadeDigitadaEConvertida();
    if (this.pedidoService.pedido) {
      this.pedido = this.pedidoService.pedido;
      this.validaEstoque = this.pedidoService.pedido.tipo.validaEstoque;
    }
    if (this.product?.quantidade_minima) {
      this.minQuantidade = this.product.quantidade_minima;
    }
    if (this.product?.multiplo) {
      this.inputClass = "disabled";
    }
    this.quantity = this.getQuantidadeDigitadaOrQuantidade();
  }
}
